/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT,
  NOTIFICATION_SETTINGS_VARIANT
} from './notifications.constants'
import { TranslationDictionary } from '@plandi/common'
//import { NotificationSettingsOptions } from './notifications.types'

//export const NOTIFICATIONS_SETTINGS: NotificationSettingsOptions = {
export const getNotificationsSettings: any = (
  translate?: TranslationDictionary['data']
) => {
  return {
    office: [
      {
        title: translate?.['office-site']['settings-page']['tasks'],
        key: 'options-office-tasks',
        fields: [
          {
            name: translate?.['office-site']['settings-page']['new-task'],
            key: 'new-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page'][
              'new-important-task'
            ],
            key: 'new-primary-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page']['ended-task'],
            key: 'overdue-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page'][
              'new-files-to-task'
            ],
            key: 'new-file-in-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page'][
              'new-comments-to-task'
            ],
            key: 'new-comment-in-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page'][
              'edit-status-task'
            ],
            key: 'change-status-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['office-site']['settings-page']['edit-date-task'],
            key: 'change-timing-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      },
      {
        title: translate?.['office-site']['projects'],
        key: 'options-office-projects',
        fields: [
          {
            name: translate?.['project-invitation'],
            key: 'invite-project',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['rescheduling-project'],
            key: 'change-terms',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['rescheduling-section'],
            key: 'change-part-terms',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['changing-the-reference'],
            key: 'change-update-technical-task',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['project-status-change'],
            key: 'change-status',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['participant-leave-project'],
            key: 'member-exit-project',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            name: translate?.['role-change'],
            key: 'change-role',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      },
      {
        title: translate?.['office-site']['settings-page']['other'],
        key: 'options-office-others',
        fields: [
          {
            name: translate?.['office-site']['settings-page'][
              'term-completion'
            ],
            key: 'end-action-packet',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      }
    ],
    job: [
      {
        key: 'options-specialists',
        title: translate?.['office-site']['settings-page']['for-specialists'],
        fields: [
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.RECOMMENDED_TENDERS,
            name: 'Рекомендуемые заказы',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.FEEDBACKS_AND_MESSAGES,
            name: translate?.['office-site']['settings-page'][
              'feedbacks-messages'
            ],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.VERIFY_STATUS,
            name: translate?.['office-site']['settings-page'][
              'status-verified'
            ],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.LIKES_PROJECTS,
            name: translate?.['office-site']['settings-page']['likes-and-work'],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      },
      {
        key: 'options-companies',
        title: translate?.['office-site']['settings-page']['for-company'],
        fields: [
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.RECOMMENDED_TENDERS,
            name: 'Рекомендуемые заказы',
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.FEEDBACKS_AND_MESSAGES,
            name: translate?.['office-site']['settings-page'][
              'feedbacks-messages'
            ],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.LIKES_PROJECTS,
            name: translate?.['office-site']['settings-page']['likes-and-work'],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      },
      {
        key: 'options-others',
        title: translate?.['office-site']['settings-page']['other'],
        fields: [
          {
            key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.PACKET_EXPIRATION_DATE,
            name: translate?.['office-site']['settings-page'][
              'term-completion'
            ],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      }
    ],
    shop: [
      {
        key: 'options-shop-projects',
        title: translate?.['office-site']['projects'],
        fields: [
          {
            key: 'messages',
            name: translate?.messages.title,
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: 'add-project-to-favorite',
            name: translate?.['office-site']['settings-page'][
              'add-favorite-project'
            ],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      },
      {
        key: 'options-shop-models',
        title: translate?.models,
        fields: [
          {
            key: 'messages',
            name: translate?.messages.title,
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          },
          {
            key: 'add-project-to-favorite',
            name: translate?.['add-model-favorite'],
            defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
          }
        ]
      }
    ]
  }
}
